/**
 * useAdminAuth - checkPermission, checkRole for admin panel RBAC.
 * Uses user.permissions from login response (stored in localStorage).
 * Mirrors digi-gold-web-admin-react: token = authenticated.
 */
import { useState, useEffect } from "react";
import { getAdminUser, getAdminToken } from "../utils/adminAuth";

export function useAdminAuth() {
  const [user, setUser] = useState(() => getAdminUser());

  useEffect(() => {
    setUser(getAdminUser());
  }, []);

  const token = getAdminToken();
  const effectiveUser = user ?? getAdminUser();

  const checkPermission = (permission) => {
    const u = effectiveUser ?? getAdminUser();
    if (!u?.permissions || !Array.isArray(u.permissions)) return false;
    const perm = (permission || "").toUpperCase();
    if (!perm) return false;
    return u.permissions.includes(perm);
  };

  const checkRole = (roleName) => {
    const u = effectiveUser ?? getAdminUser();
    if (!u?.role) return false;
    return (u.role || "").toLowerCase() === (roleName || "").toLowerCase();
  };

  const hasAnyPermission = (perms) => {
    if (!perms?.length) return false;
    return perms.some((p) => checkPermission(p));
  };

  const hasAllPermissions = (perms) => {
    if (!perms?.length) return true;
    return perms.every((p) => checkPermission(p));
  };

  return {
    user: effectiveUser,
    token,
    checkPermission,
    checkRole,
    hasAnyPermission,
    hasAllPermissions,
    isAuthenticated: Boolean(token),
  };
}
